import React from 'react'
import "./BlogPost.css";

import happyholiday from "../../Assets/b59/happyholiday.jpg"

function Blog59() {
    return (
        <div className='container-fluid my-5'>
            <div className='row mb-5'>
                <div className='col blog-text text-center'>
                    <h1>Happy Holidays from MYT Solutions! 🎄✨</h1>
                    <h6>December 30, 2024 at 10:59 AM</h6>
                </div>
            </div>

            <div className='row align-items-center justify-content-center mx-5 gx-5 gy-5'>
                <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-5 col-xxl-5'>
                    <img src={happyholiday} className="blog-img" alt="..." />
                </div>
                <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6 blog-text'>
                    <p>As 2024 comes to a close, we want to express our heartfelt gratitude to everyone who made this year extraordinary. From our amazing team to our valued partners — thank you for being part of our journey. 💙</p>
                    <p>May your holidays be filled with joy, love, and celebration, and may the New Year bring fresh opportunities and success your way! 🌟</p>
                    <p><a href='https://www.facebook.com/hashtag/happyholidays' target='_blank' className='blog-link'>
                        #HappyHolidays</a>
                        <a href='https://www.facebook.com/hashtag/mytculture' target='_blank' className='blog-link'>
                        #MYTCulture</a>
                        <a href='https://www.facebook.com/hashtag/bringiton202' target='_blank' className='blog-link'>
                        #Bringiton2025</a>
                    </p>
                </div>
            </div>
        </div>
    )
}

export default Blog59
